import { authApiCall } from '../auth/saga';

export const generateText = ({ prompt, type, length }) =>
  authApiCall({
    url: '/coupons/generate-text/',
    method: 'post',
    data: { prompt, type, length },
  });

export const generateImage = ({ prompt }) =>
  authApiCall({
    url: '/coupons/generate-image/',
    method: 'post',
    data: { prompt },
  });
